module.exports = __webpack_public_path__ + "img/nogonolcardgap-min.a1da9a73.jpg";